import React, { useState } from 'react';
import { useAuth } from '../../lib/auth';
import { peut } from '../../lib/permissions';
import { pretPourExportFiscal } from '../../lib/store';
import { fiscal, moisCourantTunis, requeteExport, telechargerFiscal } from '../../lib/exportsFiscaux';

const OPTIONS = {
  ventes: { module: 'facturier', titre: 'Exporter journal des ventes (mois)' },
  rs: { module: 'frais-generaux', titre: 'Exporter état RS (mois)' },
  cnss: { module: 'pointage-paie', titre: 'Exporter état préparatoire CNSS (mois)' },
};
export default function ExportFiscalMensuel({ type }) {
  const { user } = useAuth();
  const [mois, setMois] = useState(moisCourantTunis);
  const [occupe, setOccupe] = useState(false);
  const [erreur, setErreur] = useState('');
  const [resultat, setResultat] = useState(null);
  const cfg = OPTIONS[type];
  if (!cfg || !['Administrateur', 'Comptable'].includes(user?.role) || !peut(user.role, cfg.module)) return null;
  async function exporter() {
    if (occupe) return;
    setErreur(''); setResultat(null);
    if (!pretPourExportFiscal()) {
      setErreur('Les données ne sont pas encore chargées ou des saisies attendent leur enregistrement serveur. Attendez la synchronisation avant de réessayer.'); return;
    }
    setOccupe(true);
    try {
      const data = await fiscal(requeteExport(type, mois));
      if (!pretPourExportFiscal()) throw new Error('Des saisies ont changé pendant la préparation : attendez leur synchronisation puis réexportez.');
      telechargerFiscal(data); setResultat(data);
    } catch (e) { setErreur(e.message); }
    finally { setOccupe(false); }
  }
  return <section className="border border-slate-200 bg-white p-4 space-y-3" aria-label={cfg.titre}>
    <div className="flex flex-wrap items-end gap-3">
      <label className="text-sm font-semibold">Mois de préparation
        <input type="month" aria-label={`Mois ${type}`} value={mois} disabled={occupe}
          onChange={e => { setMois(e.target.value); setResultat(null); setErreur(''); }}
          className="block border border-slate-300 p-2 mt-1" />
      </label>
      <button type="button" disabled={occupe || !mois} onClick={exporter}
        className="border border-slate-900 bg-slate-900 text-white px-4 py-2 disabled:opacity-50">
        {occupe ? 'Préparation…' : cfg.titre}
      </button>
    </div>
    <p className="text-xs text-slate-600">Fichier de travail du comptable, issu des données enregistrées. Aucun dépôt fiscal ou social. Les valeurs manquantes restent à vérifier.</p>
    {erreur && <p role="alert" className="text-sm text-red-700">{erreur}</p>}
    {resultat && <div aria-live="polite" className="text-sm space-y-2">
      <p>{resultat.lignes} ligne(s) téléchargée(s) — état préparatoire.</p>
      {resultat.avertissements?.length > 0 && <div role="alert" className="border border-amber-400 bg-amber-50 p-3">
        <p className="font-semibold">Points à vérifier ({resultat.avertissements.length})</p>
        <ul className="list-disc pl-5 max-h-72 overflow-auto">{resultat.avertissements.map((a, i) => <li key={i}>{a}</li>)}</ul>
      </div>}
    </div>}
  </section>;
}
